import { sanitizeHtml } from "@/lib/tool-kit/developer/html/sanitize";
import {
  type MarkdownOptions,
  renderMarkdown,
} from "@/lib/tool-kit/developer/markdown/render";
import { escapeHtml } from "@/lib/tool-kit/developer/markdown/text";

/** Above this, the converter would still work but the live preview would lag. */
export const MAX_MARKDOWN_LENGTH = 200_000;

export interface MarkdownConversion {
  /** The HTML to copy or download. Sanitised whenever raw HTML was allowed through. */
  html: string;
  /** The same HTML for the on-page preview: sanitised, links opening in a new tab. */
  preview: string;
}

/** Null only if the input defeats the converter (it is guarded against nesting depth). */
export function convertMarkdown(
  source: string,
  options: MarkdownOptions
): MarkdownConversion | null {
  try {
    const rendered = renderMarkdown(
      source.slice(0, MAX_MARKDOWN_LENGTH),
      options
    );
    return {
      html: options.allowHtml ? sanitizeHtml(rendered) : rendered,
      preview: sanitizeHtml(rendered, { preview: true }),
    };
  } catch {
    return null;
  }
}

/** A complete UTF-8 HTML document around a converted fragment, for download. */
export function htmlDocument(body: string, title: string, lang = "en"): string {
  return `<!DOCTYPE html>
<html lang="${escapeHtml(lang)}">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${escapeHtml(title)}</title>
</head>
<body>
${body}</body>
</html>
`;
}
